import useSWR from 'swr'
import API from '../../../utils/api'
import { getPersistData } from '../../hooks/persist'
import { useToken } from 'app/hooks'

const KEY = '/users/sidebar?page=1&maxData=1000&usertype=' // (1) 사용자 목록 조회 2: 강사, 3: 학생

let swrData: any = getPersistData(KEY)

export function TeacherStudentSide(usertype) {
	const { data: token } = useToken()
	const { data, mutate } = useSWR<any>(
		KEY + usertype,
		async (url) => {
			const response = await API.get(url, token + '', {})
			swrData = response.result?.result?.list

			return swrData
		},
		{ revalidateOnFocus: true }
	)

	return {
		TeacherStudentData: data,
		mutate: (value?: any) => {
			if (value != undefined) {
				swrData = value
			}
			return mutate()
		},
	}
}
